const initialState = {
    fetchingCarePlane: false,
    fetchingCarePlaneSuccess: false,
    healthCondition: [],
    dailyActivity: [],
    dailyActivityInfo: "",
    healthConditionInfo: "",
    patientBaseLineQuestion: [],
    baseLineLoader: false,
    fetchingPlanSpinner : false

}

export default (state = initialState, action) => {
    switch (action.type) {

        case 'updatingBaseLine_START': {
            return { ...state, baseLineLoader: true }
        }
        
        case 'updatePatientBaseLine_SUCCESS': {
            return {
                ...state,
                patientBaseLineQuestion: action.payload.Record,
                baseLineLoader: false
            }
        }

        case 'fetchingBaseLineQuestion_START': {
            return { ...state, baseLineLoader: true }
        }

        case 'fetchBaseLineQuestion_SUCCESS': {
            return {
                ...state,
                patientBaseLineQuestion: action.payload.Record,
                baseLineLoader: false
            }
        }

        case 'fetchBaseLineQuestion_FAILURE': {
            return {
                ...state,
                baseLineLoader: false
            }
        }

        case "fetchingCarePlane_START": {
            return { ...state, fetchingCarePlane: true, fetchingPlanSpinner : true }
        }

        case "fetchPatientCarePlane_SUCCESS":
            return {
                ...state,
                fetchingCarePlane: false,
                dailyActivityInfo: action.payload.dailyActivityInfo,
                healthConditionInfo: action.payload.healthConditionInfo,
                healthCondition: action.payload.healthCondition,
                dailyActivity: action.payload.dailyActivity,
                fetchingPlanSpinner : false
            }
        case "fetchPatientCarePlane_FAILURE":
            return {
                ...state,
                fetchingCarePlane: false,
                fetchingPlanSpinner : false
            }

        default:
            return state
    }
}
